import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const RaffleFAQs = (props) => {
  const [openFaqs, setOpenFaqs] = useState([]);

  const {
    raffleEnrollment: {
      campaignImages,
      campaignLogoUrl,
      campusName,
      chabadHouseName,
      gregorianYear,
      hebrewYear,
      isCociSeller,
    },
    sellerId,
    toggleShowTermsAndConditions,
    termsAndConditions,
  } = props;

  const faqs = [
    {
      q: "Why should I participate in the Grand Draw?",
      a: "By purchasing tickets in the Grand Draw, you are enabling Chabad to continue and expand its vital work on behalf of Jewish life on campus!",
    },
    {
      q: "How do I enter the Grand Draw?",
      a: (
        <>
          Visit the Grand Draw page at{" "}
          {
            <a
              href={window.location.origin}
              target="_blank"
              rel="noopener noreferrer"
              className="pointer underline-text"
            >
              {window.location.hostname}
            </a>
          }{" "}
          or mail your application along with your local ticket currency ($36
          USD, $48 CAD, £27) per entry to Chabad on Campus International, 719
          Eastern Parkway, First Floor, Brooklyn, NY, 11213.
        </>
      ),
    },
    {
      q: "Until when can I enter the Grand Draw?",
      a: "The Grand Draw closes on Wednesday, July 9, 2025, at 11:59 PM ET. That is your last chance to join!",
    },
    {
      q: "When will the Grand Draw be drawn?",
      a: "The Grand Draw drawing date is Thursday, July 10, 2025, at 1:00 PM ET.",
    },
    {
      q: "When will the Grand Draw winners be announced? ",
      a: "The Grand Draw winners will be announced on Monday, July 14, 2025, at 1:00 PM ET.",
    },
    {
      q: "How will I be notified if I win?",
      a: "The Grand Draw winners will be notified via phone, email, and/or postal mail. All prizes must be claimed within one (1) month of notification, or the prize may be forfeited.",
    },
    {
      q: "Where will the Grand Draw be drawn?",
      a: (
        <>
          Chabad on Campus International, 719 Eastern Parkway, First Floor,
          Brooklyn, NY, 11213. The results will be posted on{" "}
          {
            <a
              href={window.location.origin}
              target="_blank"
              rel="noopener noreferrer"
              className="pointer underline-text"
            >
              {window.location.hostname}
            </a>
          }{" "}
          on Monday, July 14, 2025, at 1:00 PM ET.
        </>
      ),
    },
    {
      q: "Is my Grand Draw contribution tax-deductible?",
      a: (
        <>
          The Chabad on Campus Grand Draw does not require any
          purchase/contribution. There is an alternate method of entry, and both
          methods provide the same chance of winning. This should satisfy the
          Internal Revenue Service requirement for tax deductibility. See the
          full terms and conditions{" "}
          <span
            className="pointer underline-text"
            onClick={(evt) =>
              toggleShowTermsAndConditions(evt, termsAndConditions.legalText)
            }
          >
            here
          </span>
          . Please be in touch with us at{" "}
          <a
            className="pointer underline-text"
            href="mailto:help@chabadoncampus.org"
            rel="noopener noreferrer"
          >
            help@chabadoncampus.org
          </a>{" "}
          with further questions.
        </>
      ),
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ behavior: "smooth", left: 0, top: 0 });
    }, 100);
  }, []);

  return (
    <div className="faqs-page">
      <div className="header-title fs-20 fw-900 text-center uppercase-text">
        {!!sellerId ? <p>{chabadHouseName}</p> : <p>Chabad on Campus</p>}
        <p className="bh">ב״ה</p>
      </div>
      <div className="header-logo">
        <img alt="bckg" src={campaignLogoUrl} />
        <p
          className="fs-50 fw-900 light-text mt-8 mb-72"
          style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
        >
          {`${gregorianYear}/${hebrewYear}`}
        </p>
      </div>
      <Helmet prioritizeSeoTags>
        <title>
          {`${
            sellerId
              ? `${chabadHouseName || "Chabad on Campus"} Grand Draw`
              : `Chabad on Campus Grand Draw ${gregorianYear}`
          } | Frequently Asked Questions`}
        </title>
        <meta
          name="description"
          content={`Join our grand draw and partner with us in building the Jewish future${
            sellerId && chabadHouseName
              ? ` ${isCociSeller ? "with" : "at"} ${chabadHouseName}`
              : ""
          }.`}
        />
        <meta
          name="keywords"
          content={`pledgejewish,${chabadHouseName},${campusName},raffle,grand draw,prize draw,faqs,frequently asked questions`}
        />
        <meta
          property="og:image"
          content={
            (sellerId &&
              (campaignImages.find((i) => i.isPrimary) || campaignImages[0]) // first primary or first campaign image
                ?.url) ||
            campaignLogoUrl
          }
        />
      </Helmet>
      <div className="container">
        <div>
          <p className="fs-24 fw-700 text-center mb-56">
            Frequently Asked Questions
          </p>
          <div className="faqs">
            {faqs.map((faq, index) => {
              const isOpen = openFaqs.includes(index);
              return (
                <div className="faq-card" key={index}>
                  <div
                    className={`fs-22 fw-600 flex flex-justify-space ${
                      isOpen && "brand-color-text"
                    }`}
                  >
                    <p>{faq.q}</p>
                    <i
                      className="material-icons pointer ml-24"
                      onClick={() =>
                        setOpenFaqs(
                          isOpen
                            ? openFaqs.filter((f) => f !== index)
                            : [...openFaqs, index]
                        )
                      }
                    >
                      {isOpen ? "remove" : "add"}
                    </i>
                  </div>
                  {isOpen && (
                    <p className="line-height-double fs-18 mt-16">{faq.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(RaffleFAQs);
